export const appCodes = {
    auth: {
        accessToken: 'accessToken',
        accessTokenExpirationTime: 'accessTokenExpirationTime',
        refreshToken: 'refreshToken',
        refreshTokenExpirationTime: 'refreshTokenExpirationTime',
        permittedTaskList: 'permittedTaskList',
        systemParameterList: 'systemParameterList',
        settingsList: 'settingsList',
        ngOrg: 'ngOrg', //holds database name
        ngUID: 'ngUID', //holds logged user id
        staffId: 'staffId',
        staffIntId: 'staffIntId',
        staffName: 'staffName',
        staffEmail: 'staffEmail',
        staffPosition: 'staffPosition',
        staffImageId: 'staffImageId',
        staffImageData: 'staffImageData',
        appTheme: 'appTheme',
        userRedirectPageURL: 'userRedirectPageURL',
        loginUrl: 'loginUrl',
        organization: 'Organization',
        userName: 'userName',
        isRememberMe: 'isRememberMe',
        userId: 'userId',
        userCulture: 'userCulture',
        homePageUrl: 'homePageUrl',
        context: 'Context',
        commonControlUserId: 'UserId',
        sharedControl_ReferenceType: 'SharedControl_ReferenceType',
        sharedControl_ReferenceTitle: 'SharedControl_ReferenceTitle',
        sharedControl_ReferenceId: 'SharedControl_ReferenceId',
        sharedControl_EnableRecommendation: 'SharedControl_EnableRecommendation',
        applicationName: 'ApplicationName',
        commonControlApiUrl: 'CommonControlApiUrl',
        commonControlAppUrl: 'CommonControlAppUrl',
        surveyAPIUrl: 'SurveyAPIUrl',
        surveyAppUrl: 'SurveyAppUrl',
        controlId: 'controlId',
        enableSycle: 'enableSycle',
        isQuickUpdate: 'IsQuickUpdate',
        ngToken: 'ngToken',
        staticPermissions: 'staticPerm',
        servicePermissions: 'servicePerm',
        menuItems: 'menuItems',
        appConfig: 'appConfig',
        enforcePasswordPolicy: 'enforcePasswordPolicy',
        isFlexiOrgHierarchy: 'IsFlexiOrgHierarchy',
        isInitialRiskAssessmentVisible: 'isInitialRiskAssessmentVisible',
        isRevisedRiskAssessmentVisible: 'isRevisedRiskAssessmentVisible',
        isFutureRiskAssessmentVisible: 'isFutureRiskAssessmentVisible',
        clientDetailsName: 'clientDetailsName',
        fullStaffName: 'fullStaffName',
        isFromEIS: 'isFromEIS',
        tokenRefreshInterval: 'tokenRefreshInterval',
        queuedTokenList: 'queuedTokenList',
        roles: 'roles',
        linkages: 'linkages',
        actionApiUrl: 'actionApiUrl',
        actionAppUrl: 'actionAppUrl',
        riskApiUrl: 'riskApiUrl',
        CammsIncidentServiceApiUrl: 'cammsIncidentServiceApiUrl',
        CammsIncidentClientUrl: 'cammsIncidentClientUrl',
        cammsServiceApiUrl: 'cammsServiceApiUrl',
        cammsServiceClientUrl: 'cammsServiceClientUrl',
        IMS_Url: 'ims_url', //legacy app,
        sysadminAvatar: 'sysadminAvatar',
        interplanPermissions: 'interplanPermissions',
    },
};